import axios from 'axios';
import { TaskModel } from '../types';
import './axios-interceptor';

export default {
  // async getEventByStateCity(state: string, city: string) {
  //   return await axios.get(`event/list/${state}/${city}`);
  // },
  // async getEvent(param: any, searchParam: string) {
  //   return await axios.get(`event/list?limit=${param.limit}&lastIndex=${param.lastIndex}&${searchParam}`);
  // },
  async createTask(event: TaskModel) {
    return await axios.post(`task/create`, event);
  },
  async getTaskList() {
    return await axios.get(`task/list`);
  },
};
